<template>
    <div>
        <el-table
            :data="tableData"
            style="width: 100%; margin-bottom: 20px"
            row-key="id"
            border
            default-expand-all
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
            <el-table-column
                prop="childrenPolicyTypeName"
                label="分类名称"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="300">
                <template slot-scope="scope">
                    <el-button
                        @click="add(scope.row)"
                        type="primary"
                        size="small"
                        v-if="!scope.row.parentId"
                        >新增下一级</el-button
                    >
                    <el-button
                        type="success"
                        @click="compile(scope.row)"
                        v-if="scope.row.type != -1"
                        size="small"
                        >编辑</el-button
                    >
                    <el-button
                        type="danger"
                        @click="remove(scope.row)"
                        v-if="scope.row.type != -1"
                        size="small"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>

        <!--  -->
        <el-dialog
            :title="title"
            :visible.sync="visible"
            width="30%"
            :modal="false"
        >
            <div>
                <el-form
                    ref="form"
                    :model="form"
                    label-width="80px"
                    :rules="rules"
                >
                    <el-form-item label="分类名称" prop="name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// import {
//   getAllChildrenPolicyClassifyData,
//   getAllChildrenPolicyClassifyList,
//   childrenHomePolicyClassifyListEdit,
//   childrenHomePolicyClassifyListDelete
// } from "../api/index.js";
export default {
    data() {
        return {
            data: [
                {
                    id: 1,
                    label: "一级 1",
                    children: [
                        {
                            id: 4,
                            label: "二级 1-1",
                            children: [
                                {
                                    id: 9,
                                    label: "三级 1-1-1",
                                },
                                {
                                    id: 10,
                                    label: "三级 1-1-2",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 2,
                    label: "一级 2",
                    children: [
                        {
                            id: 5,
                            label: "二级 2-1",
                        },
                        {
                            id: 6,
                            label: "二级 2-2",
                        },
                    ],
                },
                {
                    id: 3,
                    label: "一级 3",
                    children: [
                        {
                            id: 7,
                            label: "二级 3-1",
                        },
                        {
                            id: 8,
                            label: "二级 3-2",
                        },
                    ],
                },
            ],
            tableData: [
                {
                    id: 3,
                    date: "2016-05-01",
                    name: "王小虎",
                    address: "上海市普陀区金沙江路 1519 弄",
                    children: [
                        {
                            id: 31,
                            date: "2016-05-01",
                            name: "王小虎",
                            address: "上海市普陀区金沙江路 1519 弄",
                        },
                        {
                            id: 32,
                            date: "2016-05-01",
                            name: "王小虎",
                            address: "上海市普陀区金沙江路 1519 弄",
                        },
                    ],
                },
            ],
            form: {},
            type: "",
            row: {},
            visible: false,
            title: "",
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入分类名称",
                        trigger: "blur",
                    },
                ],
            },
        }
    },
    methods: {
        //拿到树
        getAllChildrenPolicyClassifyListAPI(e) {
            getAllChildrenPolicyClassifyList(e).then((res) => {
                console.log("res", res)
                let arr = [
                    {
                        childrenPolicyTypeName: "信息分类主树",
                        id: 0,
                        type: -1,
                        children: [],
                    },
                ]
                arr[0].children = res.content
                this.tableData = arr
                console.log(arr)
            })
        },
        //新增
        add(row) {
            this.row = row
            this.title = "新增分类名称"
            this.visible = true
            this.type = "add"
            // childrenHomePolicyClassifyListEdit().then(res => {
            //   this.$message({
            //     type: "success",
            //     message: "新增成功!"
            //   });
            // });
        },
        //编辑
        compile(row) {
            this.visible = true
            this.title = "编辑分类名称"
            this.type = "compile"
            this.row = row
            this.$set(this.form, "name", row.childrenPolicyTypeName)
            // childrenHomePolicyClassifyListEdit().then(res => {
            //   this.$message({
            //     type: "success",
            //     message: "编辑成功!"
            //   });
            // });
        },
        //删除
        //删除
        remove(e) {
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "error",
            })
                .then(() => {
                    childrenHomePolicyClassifyListDelete({ id: e.id }).then(
                        (res) => {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            })
                            this.getAllChildrenPolicyClassifyListAPI({})
                        }
                    )
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    })
                })
        },
        //弹出框
        submit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    //根据type判断是新增还是编辑
                    if (this.type == "add") {
                        let params = {
                            parentId: this.row.id,
                            childrenPolicyTypeName: this.form.name,
                        }
                        childrenHomePolicyClassifyListEdit(params).then(
                            (res) => {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                })
                                this.visible = false
                                this.getAllChildrenPolicyClassifyListAPI({})
                            }
                        )
                    } else if (this.type == "compile") {
                        let params = {
                            parentId: this.row.parentId,
                            id: this.row.id,
                            childrenPolicyTypeName: this.form.name,
                        }
                        childrenHomePolicyClassifyListEdit(params).then(
                            (res) => {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                })
                                this.visible = false
                                this.getAllChildrenPolicyClassifyListAPI({})
                            }
                        )
                    }
                }
            })
        },
    },
    created() {
        this.getAllChildrenPolicyClassifyListAPI({})
    },
}
</script>
<style scoped>
.button {
    width: 400px;
    margin: 30px auto 0px;
    display: flex;
    justify-content: space-between;
}
.slot {
    height: 500px;
    overflow: auto;
}
.el-form-item {
    margin-bottom: 20px !important;
}
</style>>